// export default {
//     'fontUrl':"http://brightness.mynetgear.com:8081",
//     'backendUrl':'http://brightness.mynetgear.com:8081',
//     "baseFileUrl":"/hz/frontCommon/upload",
//     "uploadExcelUrl":"/hz/frontExhibitor/ZsCertificatesApply/uploadExecl",
//     "uploadExcelAudience":"/hz/frontExhibitor/populationInvite/excelBatchUploading",
//     "editPrefix":"/hzTestHoutai",
//     "backFront": "http://brightness.mynetgear.com:8081/hzTest/#/index",
//     "viewApply": 'http://brightness.mynetgear.com:8081/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c',
//     "backExhibitionList": 'http://brightness.mynetgear.com:8081/hzTest/#/exhibition',
// }


//展会官网主域名
let baseUrl = "https://www.chinaminexpo.com";
let onlineUrl  = "https://e-show.chinaminexpo.com";

// //展会官网主域名 新接口
// let baseUrl = "http://gw.demo365.cc:18081";
// let onlineUrl  = "http://gw.demo365.cc:18082";

export default {
  fontUrl: baseUrl,
  tinymceUrl:onlineUrl,  //富文本静态路径 
  
  wxImgdowngL:onlineUrl+'/exhibitor/#/wxdownImg',   //微信扫码下载图片链接

  backendUrl: baseUrl,
  baseFileUrl: '/hz/frontCommon/upload',
  uploadExcelUrl: '/hz/frontExhibitor/ZsCertificatesApply/uploadExecl',
  uploadExcelAudience: '/hz/frontExhibitor/populationInvite/excelBatchUploading',
  editPrefix: '/exhibitor',   //富文本编辑器需修改
  backFront: onlineUrl+'/#/index',
  viewApply: baseUrl+'/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c',
  backExhibitionList: onlineUrl+'/#/exhibition',
  wxRegister:"https://xzt.eastfair.com/regist/21/202110MTEz/index.html#/home?ExhID=2787",
  axiosBaseUrl:baseUrl+"/hz/",
  adminLogin:onlineUrl+"/exhibitor/#/adminLogin",
  //2021 0906 新增
  viewcz: baseUrl+"/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c",   //我要参展
  viewcg: baseUrl+"/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33", // 参展申请
  zwt:baseUrl+'/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a', //展位图
  zhrc:baseUrl+'/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6',  //展会日程
  hzzhanhui:baseUrl+'/hz/f',  //展会官网,
  
  vrUrl:'https://vrchinaminexpoexhibitor-dev.lmjx.cn', //VR官方域名
  vrUploadVideo:'https://vrchinaminexpoexhibitor-dev.lmjx.cn/#/pages/video/index',  //VR上传视频地址
  vrUploadImg:'https://vrchinaminexpoexhibitor-dev.lmjx.cn/#/pages/photo/index?phototype=2',//VR上传图片地址
  vruploadURL:"https://vrchinaminexpoexhibitor-dev.lmjx.cn/m/",

  



};
